import { connect } from "react-redux";
import AutosuggestInput from "./AutosuggestInput";

import { getSuggestions, clearSuggestions } from "./actions/overviewParams";

const mapStateToProps = (state, ownProps) => {
  const filter = state.overview.filters[ownProps.filterKey];

  return {
    suggestions: filter.suggestions,
    inputValue: filter.inputValue,
    inputValid: filter.inputValue === filter.selected.text,
    disabled: !filter.enabled
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { filterKey } = ownProps;

  return {
    onSuggestionsFetchRequested: params => {
      dispatch(getSuggestions[filterKey](params));
    },
    onSuggestionsClearRequested: () => {
      dispatch(clearSuggestions(filterKey));
    }
  };
};

const AutosuggestInputContainer = connect(mapStateToProps, mapDispatchToProps)(
  AutosuggestInput
);

export default AutosuggestInputContainer;



// WEBPACK FOOTER //
// ./src/AutosuggestInputContainer.js